<script setup>
import { ref } from "vue";

defineProps({
  contract: {
    type: Object,
    required: true,
  },
});

const formRef = ref(null);

function ruleRequiredText(val) {
  return (val != null && String(val).trim() !== "") || "Campo obrigatório";
}

function ruleRequiredCep(val) {
  const digits = String(val ?? "").replace(/\D/g, "");
  if (!digits) {
    return "Campo obrigatório";
  }
  if (digits.length !== 8) {
    return "CEP deve ter 8 dígitos";
  }
  return true;
}

async function validateForm() {
  if (!formRef.value) {
    return false;
  }
  const ok = await formRef.value.validate();
  return Boolean(ok);
}

defineExpose({
  validateForm,
});
</script>

<template>
  <div class="q-pa-md">
    <div class="title-page">Gerar Ocorrência endereço</div>
    <q-form ref="formRef" greedy @submit.prevent>
      <div class="col-12">
        <label for="rua">Nome do Cliente (Titular)</label>
        <q-input
          class="col-4 q-mt-sm"
          id="rua"
          v-model="contract.occurrenceAddress.customerName"
          placeholder="Digite aqui"
          bg-color="white"
          color="red-9"
          dense
          outlined
          :rules="[ruleRequiredText]"
        />
      </div>
      <div class="col-12 row subtitle-page">Endereço conforme consta na OS:</div>
      <div class="col-12">
        <label for="rua">Rua</label>
        <q-input
          class="col-4 q-mt-sm"
          id="rua"
          v-model="contract.occurrenceAddress.streetAddressOS"
          placeholder="Digite aqui"
          bg-color="white"
          color="red-9"
          dense
          outlined
          :rules="[ruleRequiredText]"
        />
      </div>
      <div class="col-12">
        <label for="complemento">Complemento</label>
        <q-input
          class="col-4 q-mt-sm"
          id="complemento"
          v-model="contract.occurrenceAddress.additionalInformationAddressOS"
          placeholder="Digite aqui"
          bg-color="white"
          color="red-9"
          dense
          outlined
          :rules="[ruleRequiredText]"
        />
      </div>
      <div class="col-12">
        <label for="numero">Número</label>
        <q-input
          class="col-4 q-mt-sm"
          id="numero"
          v-model="contract.occurrenceAddress.numberAddressOS"
          placeholder="Digite aqui"
          bg-color="white"
          color="red-9"
          dense
          outlined
          type="number"
          :rules="[ruleRequiredText]"
        />
      </div>
      <div class="col-12">
        <label for="bairro">Bairro</label>
        <q-input
          class="col-4 q-mt-sm"
          id="bairro"
          v-model="contract.occurrenceAddress.neighborhoodAddressOS"
          placeholder="Digite aqui"
          bg-color="white"
          color="red-9"
          dense
          outlined
          :rules="[ruleRequiredText]"
        />
      </div>
      <div class="col-12">
        <label for="cep">CEP</label>
        <q-input
          class="col-4 q-mt-sm"
          id="cep"
          v-model="contract.occurrenceAddress.zipCodeAddressOS"
          placeholder="00000000"
          bg-color="white"
          color="red-9"
          dense
          outlined
          maxlength="8"
          mask="########"
          :rules="[ruleRequiredCep]"
        />
      </div>
    </q-form>
  </div>
</template>

<style lang="scss" scoped>
.title-page {
  font-size: 1.25rem;
  font-weight: 700;
  color: red;
  margin: 0;
  margin-bottom: 1rem;
}
.subtitle-page {
  font-size: 1rem;
  font-weight: 500;
  color: grey;
  margin: 0;
  margin-bottom: 1rem;
}
</style>